import React from "react";
import { useTheme } from "../utils/theme";

const AthleticDashboard = ({ player, playerData }) => {
  const { theme } = useTheme();
  const isDarkMode = true; // OLED: always dark
  const themeStyles = {
    background: "#0f172a",
    cardBackground: "#1e293b",
    textPrimary: "#f1f5f9",
    textSecondary: "#94a3b8",
    border: "#334155",
    progressBackground: "#334155",
    selectBorder: "#334155",
    selectHover: "#475569",
  };
  const playerInfoKeys = [
    "Height",
    "Bench Press (reps)",
    "Weight",
    "Squat (1RM est.)",
    "Wingspan",
    "Power Clean",
    "Body Fat %",
  ];

  // Map keys to their corresponding data paths
  const keyToDataPath = {
    Height: "Height",
    "Bench Press (reps)": "hdi_data.bench_press_185",
    Weight: "Weight",
    "Squat (1RM est.)": "hdi_data.squat",
    Wingspan: "hdi_data.wingspan",
    "Power Clean": "hdi_data.power",
    "Body Fat %": "hdi_data.body_fat",
  };

  // Helper function to get nested property value
  const getNestedValue = (obj, path) => {
    return (
      path.split(".").reduce((acc, part) => acc && acc[part], obj) || "N/A"
    );
  };

  // Handle both single object and array of objects
  const players = Array.isArray(playerData) ? playerData : [playerData];

  const SectionTitle = ({ children }) => (
    <h2
      style={{
        color: themeStyles.textPrimary,
        fontSize: "18px",
        fontWeight: "600",
        margin: "5px 0 10px 0",
        letterSpacing: "-0.01em",
      }}
    >
      {children}
    </h2>
  );

  return (
    <div className={`${"bg-[#0a0a0a]"} `}>
      <div className="">
        {/* Strength & Power Section */}
        <div>
          {/* <h2 className={`text-xl font-bold ${'text-white'} mb-2`}>Strength & Power</h2> */}
          <SectionTitle>Strength & Power</SectionTitle>
          <div
            style={{
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
            }}
            className={`${
              "bg-gray-800"
            } rounded-lg shadow-sm p-6`}
          >
            <div className="w-full">
              <table className="min-w-full border-b rounded-lg border-gray-100/80">
                <thead className="text-gray-700 bg-gray-100">
                  <tr>
                    {playerInfoKeys.map((key, index) => (
                      <th
                        key={index}
                        className="px-4 py-3 text-sm font-semibold text-left"
                      >
                        {key}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {players.map((player, playerIndex) => (
                    <tr key={playerIndex}>
                      {playerInfoKeys.map((key, index) => {
                        const dataPath = keyToDataPath[key];
                        const value = getNestedValue(player, dataPath);
                        return (
                          <td
                            key={index}
                            className="px-4 py-3 text-sm text-gray-700"
                          >
                            {value}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* <div>
                <div
                  className={`text-sm ${
                    "text-gray-400"
                  } mb-1`}
                >
                  Height
                </div>
                <div
                  className={`text-2xl font-bold ${
                    "text-white"
                  }`}
                >
                  {playerData?.Height || "N/A"}
                </div>
              </div>

              <div>
                <div
                  className={`text-sm ${
                    "text-gray-400"
                  } mb-1`}
                >
                  Bench Press (reps)
                </div>
                <div
                  className={`text-2xl font-bold ${
                    "text-white"
                  }`}
                >
                  {player?.hdi_data?.bench_press_185
                    ? player?.hdi_data?.bench_press_185
                    : "N/A"}
                </div>
              </div>

              <div>
                <div
                  className={`text-sm ${
                    "text-gray-400"
                  } mb-1`}
                >
                  Weight
                </div>
                <div
                  className={`text-2xl font-bold ${
                    "text-white"
                  }`}
                >
                  {playerData?.Weight || "N/A"}
                </div>
              </div>

              <div>
                <div
                  className={`text-sm ${
                    "text-gray-400"
                  } mb-1`}
                >
                  Squat (1RM est.)
                </div>
                <div
                  className={`text-2xl font-bold ${
                    "text-white"
                  }`}
                >
                  {player?.hdi_data?.squat ? player?.hdi_data?.squat : "N/A"}
                </div>
              </div>

              <div>
                <div
                  className={`text-sm ${
                    "text-gray-400"
                  } mb-1`}
                >
                  Wingspan
                </div>
                <div
                  className={`text-2xl font-bold ${
                    "text-white"
                  }`}
                >
                  {player?.hdi_data?.wingspan
                    ? player?.hdi_data?.wingspan
                    : "N/A"}
                </div>
              </div>

              <div>
                <div
                  className={`text-sm ${
                    "text-gray-400"
                  } mb-1`}
                >
                  Power Clean
                </div>
                <div
                  className={`text-2xl font-bold ${
                    "text-white"
                  }`}
                >
                  {player?.hdi_data?.power ? player?.hdi_data?.power : "N/A"}
                </div>
              </div>

              <div>
                <div
                  className={`text-sm ${
                    "text-gray-400"
                  } mb-1`}
                >
                  Body Fat %
                </div>
                <div
                  className={`text-2xl font-bold ${
                    "text-white"
                  }`}
                >
                  {player?.hdi_data?.body_fat
                    ? player?.hdi_data?.body_fat
                    : "N/A"}
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AthleticDashboard;
